<template>
  <div>
    <div class="container">
      <div class="youthIntro">
        <img src="@/assets/img/team/youth/system.png" alt="system"/>
      </div>
    </div>

    <!-- //리스트 -->
  </div>
</template>

<script>
export default {
  name: 'teamYouthSystem',
  data() {
    return {
    }
  },
  methods: {
  }
}
</script>
